import { useTranslation } from 'next-i18next'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useRouter } from 'next/router'
import classNames from 'classnames/bind'

// Components
import HotBrandCard from '@/components/shared/HotBrandCard'
import HotSectionTitle from '../utils/HotSectionTitle'
import HotBrandCardSkeleton from '@/components/shared/HotBrandCard/Skeleton'
import Image from '@/components/common/Image'

// Libs
import { useRecommendMerchants } from '../../Live/components/ChoiceBrandNav/hooks/useRecommendMerchants'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
import { handleGtmClickMerchant } from '@/methods/handleGtmEvent'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'
import { GTM_LOCATION } from '@/constants/gtmEvent'
import useMedia from '@/hooks/useMedia'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

type MerchantInfo = {
  id: number
  merchantId: string
  memberInfoId: string
  brandLogo: string
  brandName: string
}

const SKELTON_COUNT = 10

const HotBrands = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const { isMobile } = useMedia()
  const { recommendMerchantsData, isRecommendMerchantsDataSuccess } = useRecommendMerchants()

  const goToMerchantInfoPage = ({ merchantId, brandName, memberInfoId }: MerchantInfo) => {
    handleRoutePushWithQuery({ router, pathname: `${ROUTE_PATH.USER}/${memberInfoId}` })
    handleGtmClickMerchant({
      location: GTM_LOCATION.LIVE,
      merchantDetail: {
        merchantId: merchantId,
        merchantName: brandName,
      },
    })
  }

  return (
    <div className={cx('hot-brands')}>
      <HotSectionTitle className={cx('hot-brands__title')}>
        <span className={cx('hot-brands__title-icon')}>
          <Image src='/images/svg/home-brands/crown.svg' fill alt='' />
        </span>
        {t('Choice_Merchant_Title')}
      </HotSectionTitle>
      {!isRecommendMerchantsDataSuccess && <HotBrandCardSkeleton count={SKELTON_COUNT} />}
      {isRecommendMerchantsDataSuccess && (
        <>
          {/* 設計稿：mobile 固定 122 寬用手滑；710 起一排 5 張、1024 起一排 8 張平均分配 */}
          <Swiper
            slidesPerView='auto'
            spaceBetween={isMobile ? 10 : 20}
            breakpoints={{
              710: { slidesPerView: 5 },
              1024: { slidesPerView: 8 },
            }}
            slidesPerGroup={1}
            pagination={{
              clickable: true,
            }}
          >
            {recommendMerchantsData?.map((merchant: MerchantInfo) => (
              <SwiperSlide key={merchant.id} className={cx('hot-brands__slide')}>
                <HotBrandCard title={merchant.brandName} logoImgUrl={merchant.brandLogo} onClick={() => goToMerchantInfoPage(merchant)} />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </div>
  )
}

export default HotBrands
